function QuizResults({ results, onRetry }) {
  const {
    results: questionResults,
    correctCount,
    totalCount,
    passed,
  } = results;

  return (
    <div className="quiz-results">
      {/* Summary */}
      <div
        className={`results-summary p-4 rounded-lg mb-4 text-center ${
          passed ? "bg-green-500/10" : "bg-red-500/10"
        }`}
        style={{
          border: passed
            ? "1px solid rgba(134, 178, 122, 0.3)"
            : "1px solid rgba(239, 68, 68, 0.3)",
        }}
      >
        <h3
          className={`text-lg font-bold mb-1 ${
            passed ? "text-green-400" : "text-red-400"
          }`}
        >
          {passed ? "Quiz Passed!" : "Quiz Not Passed"}
        </h3>
        <p className="text-sm text-zinc-300">
          {correctCount} of {totalCount} correct
        </p>
        {!passed && (
          <p className="text-xs text-zinc-400 mt-2">
            You need 100% to pass. Review the incorrect answers below and try
            again.
          </p>
        )}
      </div>

      {/* Individual question results */}
      <div className="question-results space-y-3">
        {questionResults.map((result, index) => (
          <div
            key={result.questionId}
            className={`result-item p-3 rounded-lg ${
              result.isCorrect ? "bg-green-500/5" : "bg-red-500/5"
            }`}
            style={{
              border: result.isCorrect
                ? "1px solid rgba(134, 178, 122, 0.2)"
                : "1px solid rgba(239, 68, 68, 0.2)",
            }}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-semibold text-zinc-400">
                Question {index + 1}
              </span>
              <span
                className={`text-xs font-medium ${
                  result.isCorrect ? "text-green-400" : "text-red-400"
                }`}
              >
                {result.isCorrect ? "✓ Correct" : "✗ Incorrect"}
              </span>
            </div>
            <p className="text-sm text-zinc-200 mb-2">{result.questionText}</p>

            {!result.isCorrect && (
              <div className="answer-feedback mt-3 pt-3 border-t border-zinc-700/50 space-y-1">
                <p className="text-xs text-zinc-400">
                  <span className="text-red-400 font-medium">Your answer:</span>{" "}
                  {result.userAnswers.length > 0
                    ? result.userAnswers.join(", ")
                    : "No answer"}
                </p>
                <p className="text-xs text-zinc-400">
                  <span className="text-green-400 font-medium">
                    Correct answer:
                  </span>{" "}
                  {result.correctAnswers.join(", ")}
                </p>
              </div>
            )}

            {result.explanation && (
              <p className="text-xs text-zinc-400 mt-2 italic">
                {result.explanation}
              </p>
            )}
          </div>
        ))}
      </div>

      {!passed && (
        <button
          onClick={onRetry}
          className="w-full mt-4 px-4 py-3 rounded-lg font-medium text-sm text-white transition-all"
          style={{
            background:
              "linear-gradient(135deg, rgba(165, 138, 194, 0.7), rgba(145, 118, 174, 0.7))",
            border: "1px solid rgba(165, 138, 194, 0.4)",
          }}
        >
          Try Again
        </button>
      )}
    </div>
  );
}

export default QuizResults;
